import axios from 'axios';
import API_URL from '../api/config';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

export const useFamilyAdmin = () => {

  const navigate = useNavigate();

  const query = useQuery({
    queryKey: ['userCheckFamilyAdmin'],
    queryFn: async () => {
      const res = await axios.get(
        `${API_URL}/check-family-admin-api`,
        { withCredentials: true }
      );
      return res.data;
    },
    staleTime: 0,
    cacheTime: 0,
    refetchOnMount: true
  });

  useEffect(() => {

    if (query.isLoading) return;
    const user = query.data;

    if (
      user &&
      user.password === null &&
      user.onesignal_id === null &&
      user.access === 1 || user.deactivated ===1 || user.logout ===1
    ) {
      navigate('/');
    }

  }, [query.data, query.isLoading, navigate]);

  return {
    ...query,
    isFamilyAdmin: query.data?.isFamilyAdmin,
    userId: query.data?.userId,
    familyCode: query.data?.familyCode
  };
};




  